import { afterNextRender, Component, inject } from '@angular/core';
import { MessageService } from '@pct/ng-feature-message';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { RemoveSplashAction } from '@pct/ng-feature-app-layout-state';
import { environment } from '../environment';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  imports: [RouterOutlet],
})
export class App {
  constructor() {
    // Start service
    inject(MessageService);
    const store = inject(Store);
    inject(MatIconRegistry).addSvgIconSet(
      inject(DomSanitizer).bypassSecurityTrustResourceUrl('./pct.symbol.svg'),
    );

    afterNextRender(() =>
      setTimeout(
        () => store.dispatch(new RemoveSplashAction()),
        environment.isAngularDevMode ? 0 : 1000,
      ),
    );
  }
}
